var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckbook = function SvgIconCheckbook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-checkbook_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-checkbook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M5.75 11.75h7l1.5-1.5h-8.5a.728.728 0 0 0-.534.214.72.72 0 0 0-.216.532c0 .21.072.39.216.535a.72.72 0 0 0 .534.219Zm0-3h3.5c.213 0 .39-.071.534-.214A.72.72 0 0 0 10 8.004a.734.734 0 0 0-.216-.535.72.72 0 0 0-.534-.219h-3.5a.728.728 0 0 0-.534.214.72.72 0 0 0-.216.532c0 .21.072.39.216.535a.72.72 0 0 0 .534.219ZM9.5 15h-6c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 2 13.5v-8c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06V8h-1.5V5.5h-13v8H11L9.5 15Zm8.908-4.524c.061.062.092.13.092.204 0 .075-.035.146-.104.216l-.646.666-1.313-1.312.646-.667a.298.298 0 0 1 .22-.104.3.3 0 0 1 .218.104l.887.893ZM17.312 12l-4.77 4.77a.825.825 0 0 1-.24.168.688.688 0 0 1-.292.062h-.645a.353.353 0 0 1-.26-.104.353.353 0 0 1-.105-.26v-.646a.67.67 0 0 1 .063-.292.825.825 0 0 1 .166-.24L16 10.688 17.313 12Z"
  }))));
};
export default SvgIconCheckbook;